import { Component, OnInit, OnDestroy, ViewEncapsulation, ViewChild } from '@angular/core';

import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { environment } from '../../environments/environment';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { log } from 'util';
import { FooterService } from '../footer.service';
import { parse } from 'url';


@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css']
})
export class CheckoutComponent implements OnInit, OnDestroy {
  customer_details: any;
  chekoutArray: any;
  model: any;
  discount: any = [];
  tot_amt: number;
  Inv_tot: number = 0;
  disAmt: any;
  dataresult: any = [];
  typeOneCategory: {}[];
  multiple_offer: any = [];
  currentUser: any;
  coupons: any;
  applied: number = 0;
  addMinuss2: any;
  addMinuss3: any;
  addMinuss4: any;
  addMinuss5: any;
  addMinuss7: any;
  addMinuss8: any;
  addMinuss9: any;
  addMinuss10: any;

  addMinuss_charge2: any;
  addMinuss_charge3: any;
  addMinuss_charge4: any;
  addMinuss_charge5: any;

  offer_coupon: number = 0;
  invoiceTotal: number = 0;
  feedback: boolean = false;
  mOff: boolean = true;
  hideAdd: boolean = false;
  percentof30: number;
  service_offered_id: any;
  selected_multiOffers: any = [];
  couponIndex: number;
  product_couponIndex: number;
  search: any;
  buyingProducts: any[] = [];
  tot_amt_product: number = 0;
  productOffer: any;
  product_multiple_offer: any = [];
  productcoupons: any;
  hideAdd1: boolean = false;
  product_offer_coupon: number;
  product_invoiceTotal: number = 0;
  selected_ProductMultiOffers: any = [];
  invoiceTotal_product: number;
  productsTobuy: any = {};
  service_percent: number = 0;
  product_percent: number = 0;
  pp: any = [];
  showLoader: boolean;
  readcash: number = 0;
  readg_pay: number = 0;
  readtips: number = 0;
  readcard: number = 0;
  readcheque: number = 0;
  readonline_banking: number = 0;
  readdue: number = 0;
  readsalary: number = 0;
  currDate: any;
  cus_ID: any;
  AutoProductOffer: any;
  showReward: boolean = false;
  minReward: number = 0;
  mem_person: any;
  reward_points: any;
  showWallet: boolean = false;
  cus_coupon: any;
  todayDate: string;
  variableServiceCoupon: boolean = false;
  variableServiceCouponType: any;
  variableServiceCouponMaxAmt: any;
  variableServiceCouponId: any;
  variableServiceCouponMaxPer: any;
  varserdisamt: any;
  varserdisamt1: any;
  varserdisper: any;
  // varserdisper1: any;
  varsercouponmultiple_offer: any = [];

  showAmountChangeModal: boolean = false;
  selectedItem: any = null;
  newAmount: number = 0;


  variableProductCoupon: boolean = false;
  variableProductCouponType: any;
  variableProductCouponMaxAmt: any;
  variableProductCouponId: any;
  variableProductCouponMaxPer: any;
  varprodisamt: any;
  varprodisamt1: any;
  varprodisper: any;
  varprocouponproduct_multiple_offer: any = [];
  module_access: any;
  addAccess: boolean = false;
  editAccess: boolean = false;
  viewAccess: boolean = false;
  deleteAccess: boolean = false;
  changeBilledDate: boolean = false;
  changePrice: boolean = false;
  gstEnabled: boolean = false;
  cgst: number = 0;
  sgst: number = 0;
  selectedProducts: any = [];
  stock_area_do: any = [];


  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private activerouter: ActivatedRoute,
    private _arout: ActivatedRoute,
    private _flashMessagesService: FlashMessagesService,
    private footerService: FooterService

  ) {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));

    this.couponIndex = 6;
    this.product_couponIndex = 11;
    let date = this.loginservice.getCurrentDateString();
    this.chekoutArray = [];
    this.tot_amt = 0;
    // if (JSON.parse(this.loginservice.getLocalSession('customer_details')) === null) {
    //   this.router.navigate(['billings']);
    // } else {
    // }
    // if (this.loginservice.getLocalSession('chekoutArray_' + this.customer_details['id'] + '_' + date) === null) {
    // } else {
    //   this.chekoutArray = JSON.parse(this.loginservice.getLocalSession('chekoutArray_' + this.customer_details['id'] + '_' + date));
    // }
    if (this.loginservice.getLocalSession('model') === null) {
      this.router.navigate(['billings']);
      return;
    } else {
      this.model = JSON.parse(this.loginservice.getLocalSession('model'));
    }

    if (this.loginservice.getLocalSession('selectedProducts') === null) {

    } else {
      this.selectedProducts = JSON.parse(this.loginservice.getLocalSession('selectedProducts'));
    }

    this.loginservice.cusDetail(this.model.customer_id, this.currentUser)
      .subscribe(
        data => {
          if (data['data']) {
            this.loginservice.setLocalSession(data['data'], 'customer_details');
            this.customer_details = data['data'];
            this.mem_person = data['data']['mem_person'];
            this.reward_points = data['data']['reward_points'];
          }
        }, error => { alert('Network Error cusDetail API'); });
    this.model.wallet1 = this.model.minusWallet = this.model.reward_point = this.model.minusReward = 0;
    this.model['coupon'] = this.addMinuss_charge2 = this.addMinuss_charge3 = this.addMinuss_charge4 = this.addMinuss_charge5 = this.addMinuss2 = this.addMinuss3 = this.addMinuss4 = this.addMinuss5 = this.model.offer = this.model.offer2 = this.model.offer3 = this.model.offer4 = this.model.offer5 = this.model.productoffer = this.model.productoffer2 = this.model.productoffer3 = this.model.productoffer4 = this.model.productoffer5 = '';

    if (this.currentUser.whatsAppEnabled == '1') {

    } else {
      this.model.isWhatsApp = '0';
    }
    this.loginservice.getPercent(this.currentUser)
      .subscribe(
        data => {
          this.currDate = data['date'];
          if (data['status'] === 'success') {
            this.service_percent = data['data']['service_percent'];
            this.product_percent = data['data']['product_percent'];
          } else {
            this.service_percent = 0;
            this.product_percent = 0;
          }
          this.getcheckoutNew();
        }, error => { alert('Network Error getPercent API'); });


    this.loginservice.getserviceoffered('', '3', 'checkout', '', '', this.currentUser)
      .subscribe(
        data => {
          if (data['comp_details'].length > 0) {
            this.dataresult = data['comp_details'];
          }
        }, error => { alert('Network Error getserviceoffered API'); });

    this.loginservice.getserviceoffered('', '5', 'checkout', '', '', this.currentUser)
      .subscribe(
        data => {
          if (data['comp_details'].length > 0) {
            this.productOffer = data['comp_details'];
          }
        }, error => { alert('Network Error getserviceoffered API'); });



    this.activerouter.queryParams.subscribe(params => {
      if (params && params['buyingProducts']) {
        this.tot_amt_product = JSON.parse(params['tot_amt']);
        this.search = JSON.parse(params['search']);
        let buyingProducts = JSON.parse(params['buyingProducts']);
        let mod = JSON.parse(params['model']);
        if (buyingProducts.length > 0) {
          buyingProducts.forEach(element => {
            if (!this.buyingProducts[element['brand']]) {
              this.buyingProducts[element['brand']] = [];
            }
            this.buyingProducts[element['brand']].push(element);
          });
        } else {
          this.buyingProducts = [];
        }
      } else {
        this.tot_amt_product = 0;
        this.search = [];
        this.buyingProducts = [];
      }
    }, error => { alert('Network Error params API'); });
    this.product_invoiceTotal = Math.round(this.tot_amt_product);

    this.activerouter.queryParams.subscribe(params => {
      if (params && params['buyingProducts']) {
        let buyingProductsNew = JSON.parse(params['buyingProducts']);
        if (buyingProductsNew.length > 0) {
          buyingProductsNew.forEach(element => {
            // Check if the brand array exists, if not, initialize it as an empty array
            if (!this.productsTobuy[element['brand']]) {
              this.productsTobuy[element['brand']] = [];
            }
            // Push the element into the array
            this.productsTobuy[element['brand']].push(element);
          });
        } else {
          this.productsTobuy = []
        }
      } else {
        this.productsTobuy = []
      }
    }, error => { alert('Network Error params API'); });

    this.cus_ID = this.model['customer_id'];
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(today.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    this.todayDate = today.toISOString().split('T')[0]; // yyyy-MM-dd

    this.getMembership();
  }

  getMembership() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(today.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    this.todayDate = today.toISOString().split('T')[0]; // yyyy-MM-dd
    this.loginservice.getserviceoffered('', '7', '', '', this.model, this.currentUser)
      .subscribe(
        data => {
          if (data['comp_details'].length > 0) {
            this.AutoProductOffer = data['comp_details'];
            this.minReward = data['comp_details']['0'].minReward;
            if (this.model['mem_person'] === '1' && formattedDate <= this.model['memEndDate'] && this.getKeyValues(this.buyingProducts).length > 0) {
              // this.model.productoffer = this.model['mem_id'];
              this.getOffersProduct(this.model['mem_id'], 'product', '7', 'productoffer', '', 'init')
            }
          } else {
            this.AutoProductOffer = [];
          }
        }, error => { alert('Network Error getserviceoffered API'); });
  }


  toNumConvert(value: any): number {
    return value ? Number(value) : 0;
  }

  checkModuleAcces(module_id: string): boolean {
    if (!this.module_access) {
      return false;
    }
    // Parse only if needed
    let accessArray = Array.isArray(this.module_access)
      ? this.module_access
      : JSON.parse(this.module_access);
    // Find that module
    const mod = accessArray.find(m => m.module_id == module_id);
    if (mod) {
      return true; // module exists
    } else {
      return false;
    }
  }

  ngOnInit() {
    this.footerService.hideFooter();
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.getAllstock_area();
    this.gstEnabled = this.currentUser['gstEnabled'];
    if (this.gstEnabled == true) {
      // this.cgst = 0;
      // this.sgst = 0;
      this.cgst = this.currentUser['cgst'];
      this.sgst = this.currentUser['sgst'];
    } else {
      this.cgst = 0;
      this.sgst = 0;
    }

    if (this.currentUser['module_access'] && this.currentUser['module_access'] != '') {
      if (JSON.parse(this.currentUser['module_access'])) {
        this.module_access = JSON.parse(this.currentUser['module_access'])
      } else {
        this.module_access = ''
      }
    } else {
      this.module_access = ''
    }
    this.changeBilledDate = this.checkModuleAcces('33');
    this.changePrice = this.checkModuleAcces('37');
    this.pp['product_price'] = 'no';
    if (this.model.offer == '') {
      this.hideAdd = true;
      this.hideAdd1 = true;
    }
    this.model.add_charge = 0;
    this.model.charge_name = '';

    this.model.add_charge2 = 0;
    this.model.charge_name2 = '';

    this.model.add_charge3 = 0;
    this.model.charge_name3 = '';

    this.model.add_charge4 = 0;
    this.model.charge_name4 = '';

    this.model.add_charge5 = 0;
    this.model.charge_name5 = '';


    this.model['cash'] = 0;
    this.model['g_pay'] = 0;
    this.model['tips'] = 0;
    this.model['card'] = 0;
    this.model['cheque'] = 0;
    this.model['online_banking'] = 0;
    this.model['due'] = 0;
    this.model['salary'] = 0;
    this.model['advwallet'] = 0;
    this.model['services_room'] = '';
    // this.model['mop'] = 0;
  }

  // getdisco(sid) {
  // 

  // 
  //   if (this.coupons && this.coupons.length > 0) {
  //     this.coupons['0']['offered'].forEach(element => {
  //       if (element.id === sid) {
  //         return this.coupons['0']['disAmt'];
  //       } else {
  //         return '';
  //       }
  //     });


  //   } else {
  // 
  //     return '0%';
  //   }
  // }

  getcheckoutNew() {
    this.loginservice.getcheckoutNew(this.model, this.currentUser).subscribe(
      data => {
        this.invoiceTotal = this.tot_amt = 0;
        if (data['status'] == 'success') {
          this.chekoutArray = [];
          this.chekoutArray = data['data'];
          if (data['discount'].length > 0) {
            this.discount = data['discount'];
            this.getTot();
          } else {
            this.discount = []
            this.disAmt = 0;
          }
          Object.values(this.chekoutArray).forEach(element => {
            element['list'].forEach((element: any[]) => {
              this.invoiceTotal = this.tot_amt += Math.round(parseInt(element['amount1']));
            });
          });
          this.percentof30 = (this.tot_amt * this.service_percent) / 100;
          if (data['discount'].length > 0) {
            this.invoiceTotal = Math.round(this.invoiceTotal - this.disAmt);
          }
          const NormalCategory = Object.values(this.chekoutArray).filter(item => item['type'] == '1');
          this.typeOneCategory = NormalCategory;
        } else {
          this.chekoutArray = [];
          if (this.chekoutArray.length <= 0) {
            this.invoiceTotal = this.tot_amt = 0;
          }
        }
      }, error => { alert('Network Error getcheckoutNew API'); });
  }

  getTot() {
    this.Inv_tot = 0; // Initialize Inv_tot before calculation
    let total = 0
    let discoun = 0
    this.discount.forEach(element => {
      // Check if total_amount and discounted_amt properties exist and are numbers
      if (typeof element.total_amount === 'number' && typeof element.discounted_amt === 'number') {
        // Calculate the invoice total
        this.disAmt = discoun += element.discounted_amt
      } else {
        this.disAmt = 0;
      }
    });

  }

  checkcouponexist(index, checkedItems) {
    let checkedItems3 = this.multiple_offer.filter(item => item.combine_offer == 'no');
    if (checkedItems3.length > 0) {
      return true;
    } else if (checkedItems['0']['combine_offer'] === 'no' && this.multiple_offer.length > 0) {
      return true;
    }
  }

  product_checkcouponexist(index, checkedItems) {
    let checkedItems3 = this.product_multiple_offer.filter(item => item.combine_offer == 'no');
    if (checkedItems3.length > 0) {
      return true;
    } else if (checkedItems['0']['combine_offer'] === 'no' && this.product_multiple_offer.length > 0) {
      return true;
    }
  }

  showProductcoupon() {
    if (!this.product_multiple_offer || this.product_multiple_offer.length === 0) return false;
    let showcoupon = this.product_multiple_offer.filter(offer =>
      offer && offer.type === 2
    );
    return showcoupon.length > 0;
  }

  showcoupon() {
    if (!this.multiple_offer || this.multiple_offer.length === 0) return false;
    let showcoupon = this.multiple_offer.filter(offer =>
      offer && offer.type === 2
    );
    return showcoupon.length > 0;
  }


  showSercouponVar() {
    if (!this.varsercouponmultiple_offer || this.varsercouponmultiple_offer.length === 0) return false;
    let showcoupon = this.varsercouponmultiple_offer.filter(offer =>
      offer && offer.type === 2
    );
    return showcoupon.length > 0;
  }

  showProductcouponVar() {
    if (!this.varprocouponproduct_multiple_offer || this.varprocouponproduct_multiple_offer.length === 0) return false;
    let showcoupon = this.varprocouponproduct_multiple_offer.filter(offer =>
      offer && offer.type === 2
    );
    return showcoupon.length > 0;
  }


  getOffers(id, coupon, index, name, names) {
    this.service_offered_id = '';
    this.service_offered_id = id;
    this.multiple_offer = this.multiple_offer.filter(offer => offer.id !== index);
    if (this.model.offer === '' && coupon !== 'coupon') {
      this.selected_multiOffers = this.selected_multiOffers.filter(offer => offer.type !== 1);
      this.multiple_offer = this.multiple_offer.filter(offer => offer.type !== 1);
      this.addMinuss2 = this.addMinuss3 = this.addMinuss4 = this.addMinuss5 = this.model.offer = this.model.offer2 = this.model.offer3 = this.model.offer4 = this.model.offer5 = '';
      this.invoiceTotal = Math.round(this.tot_amt);
      return false;
    }
    if (id) {
      let checkedItems = []
      let checkedItemsTest = []
      let cItemc = []
      let cItemN = []
      if (coupon === 'coupon') {
        checkedItems = this.coupons.filter(item => item.service_category_id == id);
        checkedItemsTest = this.coupons.filter(item => item.service_category_id == id);
        cItemc = this.coupons.filter(item => item.service_category_id == id);
      } else {
        checkedItems = this.dataresult.filter(item => item.service_category_id == id);
        checkedItemsTest = this.dataresult.filter(item => item.service_category_id == id);
        cItemN = this.dataresult.filter(item => item.service_category_id == id);
      }
      let checkedItem_check = this.checkcouponexist(index, checkedItems);
      if (checkedItem_check) {
        alert('This ' + checkedItems['0']['service_category'] + ' Not Applicable With Other Offers & Coupon')
        this._flashMessagesService.show('This ' + checkedItems['0']['service_category'] + ' Not Applicable With Other Offers & Coupon', { cssClass: 'alert-danger' });
        // this.multiple_offer = this.multiple_offer.filter(offer => offer.type !== 2);
        // this.model.coupon = '';
        setTimeout(() => {
          this.model[name] = '';
          this.hideAdd = true;
        }, 200);
        this.multiple_offer = this.multiple_offer.filter(offer => offer.id !== index);
        this.offer_coupon = 0;
        this.multiple_offer.forEach(element => {
          this.offer_coupon += element.dis_amt;
        });
        this.invoiceTotal = Math.round(this.tot_amt - this.disAmt - this.offer_coupon)
        return false;
      }

      this.loginservice.checkLimit(this.model.id, id, checkedItems['0'], this.currentUser).subscribe(
        data => {
          if ((data >= checkedItems['0']['cus_limit']) && (checkedItems['0']['cus_limit'] > 0)) {
            alert('Customer Limit Exceeded For This Offer');
            this._flashMessagesService.show('Customer Limit Exceeded For This Offer', { cssClass: 'alert-danger' });
            setTimeout(() => {
              this.model[name] = '';
              // this.addMinus('2', index, name);
              // if (this.model['offer'] = '') {
              //   this.multiple_offer = [];
              // }
            }, 200);
            this.offer_coupon = 0;
            this.multiple_offer.forEach(element => {
              this.offer_coupon += element.dis_amt;
            });
            this.invoiceTotal = Math.round(this.tot_amt - this.disAmt - this.offer_coupon)
            return false;
          } else {
            this.model[name] = '';
            this.model[name] = id;
            if (names === 'coupons') {
              this.hideAdd = true;
            } else {
              if (checkedItems['0']['combine_offer'] === 'no') {
                this.hideAdd = false;
                let addmin = 'addMinuss' + index;
                this[addmin] = '';
                // this.model[name] = '';

              } else {
                this.hideAdd = true;
              }
            }
            // Iterate over each object in checkedItems
            let allMatch = true;


            if (checkedItems['0']['takeall'] == 'no') {
              // Iterate over each object in checkedItems
              checkedItems.forEach((checkedItem) => {
                // Iterate over each object in checkedItem['offered']
                checkedItem.offered.forEach((offeredItem) => {
                  // Iterate over each object in this.typeOneCategory
                  this.typeOneCategory.forEach((typeOneItem) => {
                    // Iterate over each object in typeOneItem['list']
                    typeOneItem['list'].forEach((listItem) => {
                      // Check if the ori_id matches with the service_category_id
                      // and id matches with the service_desc_id
                      if (offeredItem.id === listItem.service_desc_id) {
                        // If the match is found, do something
                        allMatch = true;

                        // break;
                      }
                    });
                  });
                });
              });
            } else {
              // Iterate over each object in checkedItems
              checkedItems.forEach((checkedItem) => {
                // Iterate over each object in checkedItem['offered']
                checkedItem.offered.forEach((offeredItem) => {
                  // Find if there is a match in this.typeOneCategory
                  const matchFound = this.typeOneCategory.some((typeOneItem) => {
                    return typeOneItem['list'].some((listItem) => {
                      return (
                        offeredItem.ori_id === listItem.service_category_id &&
                        offeredItem.id === listItem.service_desc_id
                      );
                    });
                  });
                  // If no match found, set the flag to false and break the loop
                  if (!matchFound) {
                    allMatch = false;
                    return;
                  }
                });
              });
            }
            // Check if all items match
            if (allMatch) {

              this.calculateOffer(checkedItems, index, coupon, name, checkedItemsTest);
            } else {
              setTimeout(() => {
                if (coupon === 'coupon') {
                  this.model.coupon = ''
                  this.applied = 0;
                } else if (name === 'offer') {
                  this.model['offer'] = "";
                } else if (name === 'offer2') {
                  this.model.offer2 = ''
                } else if (name === 'offer3') {
                  this.model.offer3 = ''
                } else if (name === 'offer4') {
                  this.model.offer4 = ''
                } else if (name === 'offer5') {
                  this.model.offer5 = ''
                }
              }, 200);
              alert('Offer Not Applicable')
              this._flashMessagesService.show('Offer Not Applicable', { cssClass: 'alert-danger' });
            }
          }
        }, error => { alert('Network Error saveAccess API'); });
    } else {
      // 
      // 
      // 
      // 



      if (this.model.offer === '') {
        this.selected_multiOffers = this.selected_multiOffers.filter(offer => offer.type !== 1);


        this.multiple_offer = this.multiple_offer.filter(offer => offer.type !== 1);
        this.addMinuss2 = this.addMinuss3 = this.addMinuss4 = this.addMinuss5 = this.model.offer = this.model.offer2 = this.model.offer3 = this.model.offer4 = this.model.offer5 = '';
      } else {
        this.selected_multiOffers = this.selected_multiOffers.filter(offer => offer.index !== index);
        this.multiple_offer = this.multiple_offer.filter(offer => offer.id !== index);
      }
      this.offer_coupon = 0;
      this.multiple_offer.forEach(element => {
        this.offer_coupon += element.dis_amt;
      });
      this.hideAdd = true;
      this.invoiceTotal = Math.round(this.tot_amt - this.disAmt - this.offer_coupon)
    }
  }


  getOffersProduct(id, coupon, index, name, names, init) {

    this.service_offered_id = '';
    this.service_offered_id = id;

    this.product_multiple_offer = this.product_multiple_offer.filter(offer => offer.id !== index);

    if (this.model.productoffer === '' && coupon != 'productcoupon' && this.model['mem_person'] !== '1') {
      this.selected_ProductMultiOffers = this.selected_ProductMultiOffers.filter(offer => offer.type !== 1);


      this.product_multiple_offer = this.product_multiple_offer.filter(offer => offer.type !== 1);
      this.addMinuss7 = this.addMinuss8 = this.addMinuss9 = this.addMinuss10 = this.model.productoffer = this.model.productoffer2 = this.model.productoffer3 = this.model.productoffer4 = this.model.productoffer5 = '';
      // alert('sss')

      this.product_offer_coupon = 0;
      this.product_multiple_offer.forEach(element => {
        this.product_offer_coupon += element.dis_amt;
      });
      this.hideAdd1 = true;
      this.product_invoiceTotal = Math.round(this.tot_amt_product - this.product_offer_coupon)
      // alert('sss')
      return false;
    }


    if (id) {
      let checkedItems = []
      if (coupon === 'productcoupon') {
        checkedItems = this.productcoupons.filter(item => item.service_category_id == id);
      } else {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(today.getDate()).padStart(2, '0');

        const formattedDate = `${year}-${month}-${day}`;
        if (this.model['mem_person'] === '1' && formattedDate <= this.model['memEndDate'] && init) {

          checkedItems = this.AutoProductOffer.filter(item => item.service_category_id == id);
          checkedItems[0]['disAmt'] = checkedItems[0]['memRetailDis'];
        } else {
          checkedItems = this.productOffer.filter(item => item.service_category_id == id);
        }
      }


      let checkedItem_check = this.product_checkcouponexist(index, checkedItems);

      if (checkedItem_check) {
        alert('This ' + checkedItems['0']['service_category'] + ' Not Applicable With Other Offers & Coupon')
        this._flashMessagesService.show('This ' + checkedItems['0']['service_category'] + ' Not Applicable With Other Offers & Coupon', { cssClass: 'alert-danger' });
        setTimeout(() => {
          this.model[name] = '';
          this.hideAdd1 = true;
        }, 200);
        this.product_multiple_offer = this.product_multiple_offer.filter(offer => offer.id !== index);
        this.product_offer_coupon = 0;
        this.product_multiple_offer.forEach(element => {
          this.product_offer_coupon += element.dis_amt;
        });
        this.product_invoiceTotal = Math.round(this.tot_amt_product - this.product_offer_coupon)
        return false;
      }

      this.loginservice.checkLimit(this.model.id, id, checkedItems['0'], this.currentUser).subscribe(
        data => {
          if ((data >= checkedItems['0']['cus_limit']) && (checkedItems['0']['cus_limit'] > 0)) {
            alert('Customer Limit Exceeded For This Offer');
            this._flashMessagesService.show('Customer Limit Exceeded For This Offer', { cssClass: 'alert-danger' });
            setTimeout(() => {
              this.model[name] = '';
              // this.addMinus('2', index, name);
              // if (this.model['offer'] = '') {
              //   this.multiple_offer = [];
              // }
            }, 200);
            this.product_offer_coupon = 0;
            this.product_multiple_offer.forEach(element => {
              this.product_offer_coupon += element.dis_amt;
            });
            this.product_invoiceTotal = Math.round(this.tot_amt_product - this.product_offer_coupon);
            return false;
          } else {
            this.model[name] = '';
            this.model[name] = id;
            if (names === 'productcoupons') {
              this.hideAdd1 = true;
            } else {
              if (checkedItems['0']['combine_offer'] === 'no') {
                this.hideAdd1 = false;
                let addmin = 'addMinuss' + index;
                this[addmin] = '';
                // this.model[name] = '';

              } else {
                this.hideAdd1 = true;
              }
            }
            // Iterate over each object in checkedItems
            let allMatch = true;
            if (checkedItems['0']['takeall'] == 'no') {
              // Iterate over each object in checkedItems
              checkedItems.forEach((checkedItem) => {
                // Iterate over each object in checkedItem['offered']
                checkedItem.offered.forEach((offeredItem) => {
                  // Iterate over each object in this.typeOneCategory
                  Object.values(this.buyingProducts).forEach((typeOneItem) => {


                    // Iterate over each object in typeOneItem['list']
                    // Check if the ori_id matches with the service_category_id
                    // and id matches with the service_desc_id
                    if (offeredItem.id === typeOneItem.id
                    ) {
                      // If the match is found, do something
                      allMatch = true;

                      // break;
                    }
                  });
                });
              });
            } else {
              // Iterate over each object in checkedItems
              checkedItems.forEach((checkedItem) => {
                // Iterate over each object in checkedItem['offered']
                checkedItem.offered.forEach((offeredItem) => {
                  // Find if there is a match in this.typeOneCategory
                  const matchFound = Object.values(this.buyingProducts).some((typeOneItem) => {

                    return typeOneItem.some((listItem) => {
                      return (
                        offeredItem.id === listItem.id
                      );
                    });
                  });

                  // If no match found, set the flag to false and break the loop
                  if (!matchFound) {
                    allMatch = false;
                    return;
                  }
                });
              });
            }


            // Check if all items match
            if (allMatch) {
              this.calculateProductOffer(checkedItems, index, coupon, name);
            } else {
              setTimeout(() => {
                if (coupon === 'productcoupon') {
                  this.model.productcoupon = ''
                  this.applied = 0;
                } else if (name === 'productoffer') {
                  this.model['productoffer'] = "";
                } else if (name === 'productoffer2') {
                  this.model.productoffer2 = ''
                } else if (name === 'productoffer3') {
                  this.model.productoffer3 = ''
                } else if (name === 'productoffer4') {
                  this.model.productoffer4 = ''
                } else if (name === 'productoffer5') {
                  this.model.productoffer5 = ''
                }
              }, 200);
              alert('Offer Not Applicable')
              this._flashMessagesService.show('Offer Not Applicable', { cssClass: 'alert-danger' });
            }
          }
        }, error => { alert('Network Error saveAccess API'); });
    } else {
      if (this.model.productoffer === '') {
        this.selected_ProductMultiOffers = this.selected_ProductMultiOffers.filter(offer => offer.type !== 1);


        this.product_multiple_offer = this.product_multiple_offer.filter(offer => offer.type !== 1);
        this.addMinuss7 = this.addMinuss8 = this.addMinuss9 = this.addMinuss10 = this.model.productoffer = this.model.productoffer2 = this.model.productoffer3 = this.model.productoffer4 = this.model.productoffer5 = '';

      } else {
        this.selected_ProductMultiOffers = this.selected_ProductMultiOffers.filter(offer => offer.index !== index);
        this.product_multiple_offer = this.product_multiple_offer.filter(offer => offer.id !== index);
      }
      this.product_offer_coupon = 0;
      this.product_multiple_offer.forEach(element => {
        this.product_offer_coupon += element.dis_amt;
      });
      this.hideAdd1 = true;
      this.product_invoiceTotal = Math.round(this.tot_amt_product - this.product_offer_coupon)
    }
  }

  calculateProductOffer(checkedItems, index, coupon, name) {

    // alert(this.tot_amt)
    // this.selected_multiOffers = this.selected_multiOffers.filter(offer => offer.index !== index);
    let addAmt = 0;

    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(today.getDate()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;
    if (this.model['mem_person'] === '1' && formattedDate <= this.model['memEndDate']) {
      Object.values(this.buyingProducts).forEach((typeOneItem) => {
        typeOneItem.forEach((listItem) => {
          if (listItem['quantity_on_sales_order'] > 1) {
            addAmt += parseInt(listItem['amt_per']) * parseInt(listItem['quantity_on_sales_order']);
          } else {
            addAmt += parseInt(listItem['totalCost']);
          }

          // addAmt += this.product_invoiceTotal;

        });
      });
    } else {
      checkedItems.forEach((checkedItem) => {
        checkedItem.offered.forEach((offeredItem) => {
          Object.values(this.buyingProducts).forEach((typeOneItem) => {
            typeOneItem.forEach((listItem) => {


              if (offeredItem.id === listItem.id) {
                if (listItem['quantity_on_sales_order'] > 1) {
                  addAmt += parseInt(listItem['amt_per']) * parseInt(listItem['quantity_on_sales_order']);
                } else {
                  addAmt += parseInt(listItem['totalCost']);
                  // addAmt = this.product_invoiceTotal;
                }

              }
            });
          });
        });
      });
    }
    let multi_offer = {
      id: '',
      name: '',
      dis_amt: 0,
      tot_amt: 0,
      type: 1,
      offer_type: '',
      offer_value: '',
      partnership_coupon: '',
      partnership_coupon_value: '',
      partnership_code: '',
      product_price: this.pp.product_price,
      checkedItem: []
    };

    if (coupon === 'productcoupon') {
      multi_offer.type = 2;
      multi_offer.id = index;
    } else {

      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const day = String(today.getDate()).padStart(2, '0');

      const formattedDate = `${year}-${month}-${day}`;
      if (this.model['mem_person'] === '1' && formattedDate <= this.model['memEndDate'] && this.model['mem_id'] == checkedItems['0'].service_category_id) {
        multi_offer.type = 7;
        multi_offer.id = index;
      } else {
        multi_offer.type = 1;
        multi_offer.id = index;
      }


    }

    if ((checkedItems['0'].start_date != '' && checkedItems['0'].start_date != '0000-00-00') && (checkedItems['0'].end_date != '' && checkedItems['0'].end_date != '0000-00-00')) {
      if (checkedItems['0'].curr_date >= checkedItems['0'].start_date && checkedItems['0'].curr_date <= checkedItems['0'].end_date) {
        if (checkedItems['0']['min_amt'] > 0) {
          if (addAmt >= checkedItems['0']['min_amt']) {
            multi_offer['name'] = checkedItems['0'].service_category;
            if (checkedItems['0'].distype == 'amount') {
              multi_offer['offer_type'] = checkedItems['0'].distype;
              multi_offer['offer_value'] = checkedItems['0'].disAmt;
              multi_offer['partnership_coupon'] = checkedItems['0'].partnership_coupon;
              multi_offer['partnership_code'] = checkedItems['0'].coupon_code;
              multi_offer['checkedItem'] = checkedItems['0'];
              multi_offer['dis_amt'] = parseInt(checkedItems['0'].disAmt);
              multi_offer['dis_amt'] = parseFloat(multi_offer['dis_amt'].toFixed(1));

              checkedItems[0]['newOffer_id'] = index;
              multi_offer['combine_offer'] = checkedItems[0]['combine_offer'];
              this.checkProductexist(checkedItems[0], index, coupon, multi_offer);
              checkedItems['0'] = '';
            }

            if (checkedItems['0'].distype == 'percentage') {
              multi_offer['offer_type'] = checkedItems['0'].distype;
              multi_offer['partnership_coupon'] = checkedItems['0'].partnership_coupon;
              multi_offer['partnership_code'] = checkedItems['0'].coupon_code;
              multi_offer['offer_value'] = checkedItems['0'].disAmt;
              multi_offer['checkedItem'] = checkedItems['0'];
              multi_offer['dis_amt'] = (addAmt / 100) * parseInt(checkedItems['0'].disAmt);
              multi_offer['dis_amt'] = parseFloat(multi_offer['dis_amt'].toFixed(1));
              checkedItems[0]['newOffer_id'] = index;
              multi_offer['combine_offer'] = checkedItems[0]['combine_offer'];
              this.checkProductexist(checkedItems[0], index, coupon, multi_offer);
              checkedItems['0'] = '';
            }
          } else {
            if (coupon === 'productcoupon') {
              this.model.productcoupon = ''
              this.removeProductcoupon('', '');
            } else {
              this.model.productoffer = ''
            }
            alert('Offer Not Applicable. To avail This Offer Min Purchase Amount Is ' + checkedItems['0']['min_amt'])
            this._flashMessagesService.show('Offer Not Applicable. To avail This Offer Min Purchase Amount Is ' + checkedItems['0']['min_amt'], { cssClass: 'alert-danger' });
            return false;
          }
        } else {
          multi_offer['name'] = checkedItems['0'].service_category;
          if (checkedItems['0'].distype == 'amount') {
            multi_offer['offer_type'] = checkedItems['0'].distype;
            multi_offer['partnership_coupon'] = checkedItems['0'].partnership_coupon;
            multi_offer['partnership_code'] = checkedItems['0'].coupon_code;
            multi_offer['offer_value'] = checkedItems['0'].disAmt;
            multi_offer['checkedItem'] = checkedItems['0'];
            multi_offer['dis_amt'] = parseInt(checkedItems['0'].disAmt);
            multi_offer['dis_amt'] = parseFloat(multi_offer['dis_amt'].toFixed(1));
            checkedItems[0]['newOffer_id'] = index;
            multi_offer['combine_offer'] = checkedItems[0]['combine_offer'];
            this.checkProductexist(checkedItems[0], index, coupon, multi_offer);
            checkedItems['0'] = '';
          } else if (checkedItems['0'].distype == 'percentage') {
            multi_offer['offer_type'] = checkedItems['0'].distype;
            multi_offer['partnership_coupon'] = checkedItems['0'].partnership_coupon;
            multi_offer['partnership_code'] = checkedItems['0'].coupon_code;
            multi_offer['offer_value'] = checkedItems['0'].disAmt;
            multi_offer['checkedItem'] = checkedItems['0'];
            multi_offer['dis_amt'] = (addAmt / 100) * parseInt(checkedItems['0'].disAmt);
            multi_offer['dis_amt'] = parseFloat(multi_offer['dis_amt'].toFixed(1));
            checkedItems[0]['newOffer_id'] = index;
            multi_offer['combine_offer'] = checkedItems[0]['combine_offer'];
            this.checkProductexist(checkedItems[0], index, coupon, multi_offer);
            checkedItems['0'] = '';
          }
        }
      } else {
        alert('Offer Expired')
        this._flashMessagesService.show('Offer Expired', { cssClass: 'alert-danger' });
        if (coupon === 'productcoupon') {
          this.model.productcoupon = ''
        } else {
          this.model.productoffer = ''
        }
        return false
      }
    } else {
      if (checkedItems['0']['disAmt'] > 0) {

        if (checkedItems['0']['min_amt'] > 0) {
          if (addAmt >= checkedItems['0']['min_amt']) {
            multi_offer['name'] = checkedItems['0'].service_category;
            if (checkedItems['0'].distype == 'amount') {
              multi_offer['offer_type'] = checkedItems['0'].distype;
              multi_offer['partnership_coupon'] = checkedItems['0'].partnership_coupon;
              multi_offer['partnership_code'] = checkedItems['0'].coupon_code;
              multi_offer['offer_value'] = checkedItems['0'].disAmt;
              multi_offer['checkedItem'] = checkedItems['0'];
              multi_offer['dis_amt'] = parseInt(checkedItems['0'].disAmt);
              multi_offer['dis_amt'] = parseFloat(multi_offer['dis_amt'].toFixed(1));
              checkedItems[0]['newOffer_id'] = index;
              multi_offer['combine_offer'] = checkedItems[0]['combine_offer'];
              this.checkProductexist(checkedItems[0], index, coupon, multi_offer);
              checkedItems['0'] = '';
            }
            if (checkedItems['0'].distype == 'percentage') {
              multi_offer['offer_type'] = checkedItems['0'].distype;
              multi_offer['partnership_coupon'] = checkedItems['0'].partnership_coupon;
              multi_offer['partnership_code'] = checkedItems['0'].coupon_code;
              multi_offer['offer_value'] = checkedItems['0'].disAmt;
              multi_offer['checkedItem'] = checkedItems['0'];
              multi_offer['dis_amt'] = (addAmt / 100) * parseInt(checkedItems['0'].disAmt);
              multi_offer['dis_amt'] = parseFloat(multi_offer['dis_amt'].toFixed(1));
              checkedItems[0]['newOffer_id'] = index;
              multi_offer['combine_offer'] = checkedItems[0]['combine_offer'];
              this.checkProductexist(checkedItems[0], index, coupon, multi_offer);
              checkedItems['0'] = '';
            }
          } else {
            if (coupon === 'productcoupon') {
              this.model.productcoupon = ''
              this.removeProductcoupon('', '');
            } else {
              this.model.productoffer = ''
            }
            alert('Offer Not Applicable. To avail This Offer Min Purchase Amount Is ' + checkedItems['0']['min_amt'])
            this._flashMessagesService.show('Offer Not Applicable. To avail This Offer Min Purchase Amount Is ' + checkedItems['0']['min_amt'], { cssClass: 'alert-danger' });
            return false;
          }
        } else {
          multi_offer['name'] = checkedItems['0'].service_category;
          if (checkedItems['0'].distype == 'amount') {
            multi_offer['offer_type'] = checkedItems['0'].distype;
            multi_offer['offer_value'] = checkedItems['0'].disAmt;
            multi_offer['partnership_coupon'] = checkedItems['0'].partnership_coupon;
            multi_offer['partnership_code'] = checkedItems['0'].coupon_code;
            multi_offer['checkedItem'] = checkedItems['0'];
            multi_offer['dis_amt'] = parseInt(checkedItems['0'].disAmt);
            multi_offer['dis_amt'] = parseFloat(multi_offer['dis_amt'].toFixed(1));

            checkedItems[0]['newOffer_id'] = index;
            multi_offer['combine_offer'] = checkedItems[0]['combine_offer'];
            this.checkProductexist(checkedItems[0], index, coupon, multi_offer);
            checkedItems['0'] = '';
          }

          if (checkedItems['0'].distype == 'percentage') {
            multi_offer['offer_type'] = checkedItems['0'].distype;
            multi_offer['partnership_coupon'] = checkedItems['0'].partnership_coupon;
            multi_offer['partnership_code'] = checkedItems['0'].coupon_code;
            multi_offer['offer_value'] = checkedItems['0'].disAmt;
            multi_offer['checkedItem'] = checkedItems['0'];
            multi_offer['dis_amt'] = (addAmt / 100) * parseInt(checkedItems['0'].disAmt);
            multi_offer['dis_amt'] = parseFloat(multi_offer['dis_amt'].toFixed(1));
            checkedItems[0]['newOffer_id'] = index;
            multi_offer['combine_offer'] = checkedItems[0]['combine_offer'];
            this.checkProductexist(checkedItems[0], index, coupon, multi_offer);
            checkedItems['0'] = '';
          }
        }

      } else {
        if (coupon === 'productcoupon') {
          this.model.productcoupon = ''
        } else {
          this.model.productoffer = ''
        }
        if (checkedItems['0']['type'] == '7') {
          return false;
        } else {
          alert('Coupon Expired')
          this._flashMessagesService.show('Coupon Expired', { cssClass: 'alert-danger' });
          return false;
        }

      }
    }

    if (this.productcoupons && this.productcoupons['0']['partnership_coupon'] == '3' && coupon === 'productcoupon') {
      if (this.variableProductCouponId) {
        alert('Coupon Already Applied');
        this._flashMessagesService.show('Coupon Already Applied', { cssClass: 'alert-danger' });
        return false;
      }
      this.varprocouponproduct_multiple_offer.push(multi_offer)
    } else {
      this.product_multiple_offer.push(multi_offer)
      this.product_offer_coupon = 0;
      this.product_multiple_offer.forEach(element => {
        this.product_offer_coupon += element.dis_amt;
      });
    }


    if (this.productcoupons && this.productcoupons['0']['partnership_coupon'] == '3' && coupon === 'productcoupon') {
      this.variableProductCouponId = multi_offer['id'];
      if (multi_offer['offer_type'] == 'percentage') {
        this.variableProductCoupon = true;
        this.variableProductCouponType = 'percentage';
        this.variableProductCouponMaxPer = multi_offer['offer_value'];
      } else {
        this.variableProductCoupon = true;
        this.variableProductCouponType = 'amount';
        this.variableProductCouponMaxAmt = multi_offer['offer_value'];
      }

    } else {
      this.percentof30 = (this.tot_amt_product * this.product_percent) / 100;

      if (this.product_offer_coupon <= this.percentof30) {
        this.product_invoiceTotal = Math.round(this.tot_amt_product - this.product_offer_coupon)
        if (coupon == 'productcoupon') {
          this._flashMessagesService.show('Coupon Applied', { cssClass: 'alert-success' });
        } else if (coupon == 'product') {
          // this._flashMessagesService.show('Coupon Applied', { cssClass: 'alert-success' });
        } else {
          alert(coupon)
          this._flashMessagesService.show('Offer Applied', { cssClass: 'alert-success' });
        }
      } else {
        if (coupon == 'productcoupon') {
          this.removeProductcoupon('', '')
        }
        setTimeout(() => {
          this.model[name] = ''; alert("More Than 30% discount Can't Be Applied")
          this._flashMessagesService.show("More Than 30% discount Can't Be Applied", { cssClass: 'alert-danger' });
        }, 300);
        this.product_multiple_offer = this.product_multiple_offer.filter(offer => offer.id !== index);
        return false;
      }


    }
    if (this.productcoupons && this.productcoupons['0']['partnership_coupon'] == '3' && coupon === 'productcoupon') {
      this.showProductcouponVar();
    } else {
      this.showProductcoupon();
    }
  }

  calculateOffer(checkedItems, index, coupon, name, checkedItemsTest) {
    // this.selected_multiOffers = this.selected_multiOffers.filter(offer => offer.index !== index);
    let addAmt = 0;
    let addAmt1 = 0;
    checkedItems.forEach((checkedItem) => {
      checkedItem.offered.forEach((offeredItem) => {
        this.typeOneCategory.forEach((typeOneItem) => {
          typeOneItem['list'].forEach((listItem) => {
            if (
              offeredItem.ori_id === listItem.service_category_id &&
              offeredItem.id === listItem.service_desc_id
            ) {
              // if (listItem['quantity'] > 1) {
              //   addAmt += listItem['amount1'] / listItem['quantity'];
              // } else {

              const today = new Date();
              const year = today.getFullYear();
              const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
              const day = String(today.getDate()).padStart(2, '0');

              const formattedDate = `${year}-${month}-${day}`;
              if (this.model['mem_person'] === '1' && formattedDate <= this.model['memEndDate']) {
                // addAmt += this.invoiceTotal;
                addAmt += listItem['amount1'];
              } else {
                addAmt += listItem['amount1'];
              }

              if (this.pp['product_price'] == 'yes') {
                if (checkedItems['0'].distype == 'percentage') {
                  addAmt1 += parseInt(listItem['product_price']) * parseInt(listItem['quantity']);
                } else {
                  addAmt1 += 0;
                }
              } else {
                addAmt1 += 0;
              }
              // }
            }
          });
        });
      });
    });

    let multi_offer = {
      id: '',
      name: '',
      dis_amt: 0,
      tot_amt: 0,
      type: 1,
      offer_type: '',
      offer_value: '',
      partnership_coupon: '',
      partnership_coupon_value: '',
      partnership_code: '',
      product_price: this.pp.product_price,
      checkedItem: []
    };

    if (coupon === 'coupon') {
      multi_offer.type = 2;
      multi_offer.id = index;
    } else {
      multi_offer.type = 1;
      multi_offer.id = index;
    }
    // 
    // 

    if ((checkedItems['0'].start_date != '' && checkedItems['0'].start_date != '0000-00-00') && (checkedItems['0'].end_date != '' && checkedItems['0'].end_date != '0000-00-00')) {
      if (checkedItems['0'].curr_date >= checkedItems['0'].start_date && checkedItems['0'].curr_date <= checkedItems['0'].end_date) {
        if (checkedItems['0']['min_amt'] > 0) {
          if (addAmt >= checkedItems['0']['min_amt']) {
            multi_offer['name'] = checkedItems['0'].service_category;
            if (checkedItems['0'].distype == 'amount') {
              multi_offer['offer_type'] = checkedItems['0'].distype;
              multi_offer['partnership_coupon'] = checkedItems['0'].partnership_coupon;
              multi_offer['partnership_code'] = checkedItems['0'].coupon_code;
              multi_offer['offer_value'] = checkedItems['0'].disAmt;
              multi_offer['checkedItem'] = checkedItems['0'];
              multi_offer['dis_amt'] = parseInt(checkedItems['0'].disAmt) - addAmt1;
              multi_offer['dis_amt'] = parseFloat(multi_offer['dis_amt'].toFixed(1));


              checkedItems[0]['newOffer_id'] = index;
              multi_offer['combine_offer'] = checkedItems[0]['combine_offer'];
              this.checkexist(checkedItems[0], index, coupon, multi_offer);
              checkedItems['0'] = '';
            }

            if (checkedItems['0'].distype == 'percentage') {
              multi_offer['offer_type'] = checkedItems['0'].distype;
              multi_offer['partnership_coupon'] = checkedItems['0'].partnership_coupon;
              multi_offer['partnership_code'] = checkedItems['0'].coupon_code;
              multi_offer['offer_value'] = checkedItems['0'].disAmt;
              multi_offer['checkedItem'] = checkedItems['0'];
              multi_offer['dis_amt'] = (addAmt / 100) * parseInt(checkedItems['0'].disAmt) - addAmt1;
              multi_offer['dis_amt'] = parseFloat(multi_offer['dis_amt'].toFixed(1));
              checkedItems[0]['newOffer_id'] = index;
              multi_offer['combine_offer'] = checkedItems[0]['combine_offer'];
              this.checkexist(checkedItems[0], index, coupon, multi_offer);
              checkedItems['0'] = '';
            }
          } else {
            if (coupon === 'coupon') {
              this.model.coupon = ''
              this.removecoupon('', '');
            } else {
              this.model.offer = ''
            }
            alert('Offer Not Applicable. To avail This Offer Min Purchase Amount Is ' + checkedItems['0']['min_amt'])
            this._flashMessagesService.show('Offer Not Applicable. To avail This Offer Min Purchase Amount Is ' + checkedItems['0']['min_amt'], { cssClass: 'alert-danger' });
            return false;
          }
        } else {
          multi_offer['name'] = checkedItems['0'].service_category;
          if (checkedItems['0'].distype == 'amount') {
            multi_offer['offer_type'] = checkedItems['0'].distype;
            multi_offer['partnership_coupon'] = checkedItems['0'].partnership_coupon;
            multi_offer['partnership_code'] = checkedItems['0'].coupon_code;
            multi_offer['offer_value'] = checkedItems['0'].disAmt;
            multi_offer['checkedItem'] = checkedItems['0'];
            multi_offer['dis_amt'] = parseInt(checkedItems['0'].disAmt) - addAmt1;
            multi_offer['dis_amt'] = parseFloat(multi_offer['dis_amt'].toFixed(1));
            checkedItems[0]['newOffer_id'] = index;
            multi_offer['combine_offer'] = checkedItems[0]['combine_offer'];
            this.checkexist(checkedItems[0], index, coupon, multi_offer);
            checkedItems['0'] = '';
          } else if (checkedItems['0'].distype == 'percentage') {
            multi_offer['offer_type'] = checkedItems['0'].distype;
            multi_offer['partnership_coupon'] = checkedItems['0'].partnership_coupon;
            multi_offer['partnership_code'] = checkedItems['0'].coupon_code;
            multi_offer['offer_value'] = checkedItems['0'].disAmt;
            multi_offer['checkedItem'] = checkedItems['0'];
            multi_offer['dis_amt'] = (addAmt / 100) * parseInt(checkedItems['0'].disAmt) - addAmt1;
            multi_offer['dis_amt'] = parseFloat(multi_offer['dis_amt'].toFixed(1));
            checkedItems[0]['newOffer_id'] = index;
            multi_offer['combine_offer'] = checkedItems[0]['combine_offer'];
            this.checkexist(checkedItems[0], index, coupon, multi_offer);
            checkedItems['0'] = '';
          }
        }
      } else {
        alert('Coupon Expired')
        this._flashMessagesService.show('Coupon Expired', { cssClass: 'alert-danger' });
        if (coupon === 'coupon') {
          this.model.coupon = ''
        } else {
          this.model.offer = ''
        }
        return false
      }
    } else {
      if (checkedItems['0']['disAmt'] > 0) {

        if (checkedItems['0']['min_amt'] > 0) {
          if (addAmt >= checkedItems['0']['min_amt']) {
            multi_offer['name'] = checkedItems['0'].service_category;
            if (checkedItems['0'].distype == 'amount') {
              multi_offer['offer_type'] = checkedItems['0'].distype;
              multi_offer['partnership_coupon'] = checkedItems['0'].partnership_coupon;
              multi_offer['partnership_code'] = checkedItems['0'].coupon_code;
              multi_offer['offer_value'] = checkedItems['0'].disAmt;
              multi_offer['checkedItem'] = checkedItems['0'];
              multi_offer['dis_amt'] = parseInt(checkedItems['0'].disAmt) - addAmt1;
              multi_offer['dis_amt'] = parseFloat(multi_offer['dis_amt'].toFixed(1));
              checkedItems[0]['newOffer_id'] = index;
              multi_offer['combine_offer'] = checkedItems[0]['combine_offer'];
              this.checkexist(checkedItems[0], index, coupon, multi_offer);
              checkedItems['0'] = '';
            }
            if (checkedItems['0'].distype == 'percentage') {
              multi_offer['offer_type'] = checkedItems['0'].distype;
              multi_offer['partnership_coupon'] = checkedItems['0'].partnership_coupon;
              multi_offer['partnership_code'] = checkedItems['0'].coupon_code;
              multi_offer['offer_value'] = checkedItems['0'].disAmt;
              multi_offer['checkedItem'] = checkedItems['0'];
              multi_offer['dis_amt'] = (addAmt / 100) * parseInt(checkedItems['0'].disAmt) - addAmt1;
              multi_offer['dis_amt'] = parseFloat(multi_offer['dis_amt'].toFixed(1));
              checkedItems[0]['newOffer_id'] = index;
              multi_offer['combine_offer'] = checkedItems[0]['combine_offer'];
              this.checkexist(checkedItems[0], index, coupon, multi_offer);
              checkedItems['0'] = '';
            }
          } else {
            if (coupon === 'coupon') {
              this.model.coupon = ''
              this.removecoupon('', '');
            } else {
              this.model.offer = ''
            }
            alert('Offer Not Applicable. To avail This Offer Min Purchase Amount Is ' + checkedItems['0']['min_amt'])
            this._flashMessagesService.show('Offer Not Applicable. To avail This Offer Min Purchase Amount Is ' + checkedItems['0']['min_amt'], { cssClass: 'alert-danger' });
            return false;
          }
        } else {
          multi_offer['name'] = checkedItems['0'].service_category;
          if (checkedItems['0'].distype == 'amount') {
            multi_offer['offer_type'] = checkedItems['0'].distype;
            multi_offer['partnership_coupon'] = checkedItems['0'].partnership_coupon;
            multi_offer['partnership_code'] = checkedItems['0'].coupon_code;
            multi_offer['offer_value'] = checkedItems['0'].disAmt;
            multi_offer['checkedItem'] = checkedItems['0'];
            multi_offer['dis_amt'] = parseInt(checkedItems['0'].disAmt) - addAmt1;
            multi_offer['dis_amt'] = parseFloat(multi_offer['dis_amt'].toFixed(1));
            checkedItems[0]['newOffer_id'] = index;
            multi_offer['combine_offer'] = checkedItems[0]['combine_offer'];
            this.checkexist(checkedItems[0], index, coupon, multi_offer);
            checkedItems['0'] = '';
          }



          if (checkedItems['0'].distype == 'percentage') {
            multi_offer['offer_type'] = checkedItems['0'].distype;
            multi_offer['partnership_coupon'] = checkedItems['0'].partnership_coupon;
            multi_offer['partnership_code'] = checkedItems['0'].coupon_code;
            multi_offer['offer_value'] = checkedItems['0'].disAmt;
            multi_offer['checkedItem'] = checkedItems['0'];
            multi_offer['dis_amt'] = (addAmt / 100) * parseInt(checkedItems['0'].disAmt) - addAmt1;
            multi_offer['dis_amt'] = parseFloat(multi_offer['dis_amt'].toFixed(1));
            checkedItems[0]['newOffer_id'] = index;
            multi_offer['combine_offer'] = checkedItems[0]['combine_offer'];
            this.checkexist(checkedItems[0], index, coupon, multi_offer);
            checkedItems['0'] = '';
          }
        }

      } else {
        if (coupon === 'coupon') {
          this.model.coupon = ''
        } else {
          this.model.offer = ''
        }
        alert('Offer Expired')
        this._flashMessagesService.show('Offer Expired', { cssClass: 'alert-danger' });
        return false;
      }
    }

    if (this.coupons && this.coupons['0']['partnership_coupon'] == '3' && coupon === 'coupon') {
      if (this.variableServiceCouponId) {
        alert('Coupon Already Applied');
        this._flashMessagesService.show('Coupon Already Applied', { cssClass: 'alert-danger' });
        return false;
      }
      this.varsercouponmultiple_offer.push(multi_offer)
    } else {
      this.multiple_offer.push(multi_offer)
      this.offer_coupon = 0;
      this.multiple_offer.forEach(element => {
        this.offer_coupon += element.dis_amt;
      });
    }
    if (coupon == 'coupon') {
      if (parseInt(checkedItemsTest['0']['exc_coupon']) !== 1) {
        if (this.coupons && this.coupons['0']['partnership_coupon'] == '3' && coupon === 'coupon') {
          this.variableServiceCouponId = multi_offer['id'];
          if (multi_offer['offer_type'] == 'percentage') {
            this.variableServiceCoupon = true;
            this.variableServiceCouponType = 'percentage';
            this.variableServiceCouponMaxPer = multi_offer['offer_value'];
          } else {
            this.variableServiceCoupon = true;
            this.variableServiceCouponType = 'amount';
            this.variableServiceCouponMaxAmt = multi_offer['offer_value'];
          }

        } else {
          if (this.offer_coupon <= this.percentof30) {
            this.invoiceTotal = Math.round(this.tot_amt - this.disAmt - this.offer_coupon)
            if (coupon == 'coupon') {
              this._flashMessagesService.show('Coupon Applied', { cssClass: 'alert-success' });
            } else {
              this._flashMessagesService.show('Offer Applied', { cssClass: 'alert-success' });
            }
          } else {
            if (coupon == 'coupon') {
              this.removecoupon('', '');
            }
            setTimeout(() => {
              this.model[name] = ''; alert("More Than " + this.service_percent + "% discount Can't Be Applied")
              this._flashMessagesService.show("More Than " + this.service_percent + "% discount Can't Be Applied", { cssClass: 'alert-danger' });
            }, 300);
            this.multiple_offer = this.multiple_offer.filter(offer => offer.id !== index);
            return false;
          }
        }
      } else {
        // this.invoiceTotal = Math.round(this.tot_amt - this.disAmt - multi_offer['dis_amt'])
        // this.invoiceTotal = Math.round(this.invoiceTotal - this.disAmt - multi_offer['dis_amt'])

        if (this.coupons && this.coupons['0']['partnership_coupon'] == '3' && coupon === 'coupon') {
          this.variableServiceCouponId = multi_offer['id'];
          if (multi_offer['offer_type'] == 'percentage') {
            this.variableServiceCoupon = true;
            this.variableServiceCouponType = 'percentage';
            this.variableServiceCouponMaxPer = multi_offer['offer_value'];
          } else {
            this.variableServiceCoupon = true;
            this.variableServiceCouponType = 'amount';
            this.variableServiceCouponMaxAmt = multi_offer['offer_value'];
          }

        } else {
          this.invoiceTotal = Math.round(this.invoiceTotal - multi_offer['dis_amt']);
          if (coupon == 'coupon') {
            this._flashMessagesService.show('Coupon Applied', { cssClass: 'alert-success' });
          } else {
            this._flashMessagesService.show('Offer Applied', { cssClass: 'alert-success' });
          }
        }
      }
    } else {
      if (this.offer_coupon <= this.percentof30) {
        this.invoiceTotal = Math.round(this.tot_amt - this.disAmt - this.offer_coupon)
        if (coupon == 'coupon') {
          this._flashMessagesService.show('Coupon Applied', { cssClass: 'alert-success' });
        } else {
          this._flashMessagesService.show('Offer Applied', { cssClass: 'alert-success' });
        }
      } else {
        if (coupon == 'coupon') {
          this.removecoupon('', '');
        }
        setTimeout(() => {
          this.model[name] = ''; alert("More Than " + this.service_percent + "% discount Can't Be Applied")
          this._flashMessagesService.show("More Than " + this.service_percent + "% discount Can't Be Applied", { cssClass: 'alert-danger' });
        }, 300);
        this.multiple_offer = this.multiple_offer.filter(offer => offer.id !== index);
        return false;
      }
    }




    if (this.coupons && this.coupons['0']['partnership_coupon'] == '3' && coupon === 'coupon') {
      this.showSercouponVar();
    } else {
      this.showcoupon();
    }
  }


  calvarsertotAmt() {
    if (this.varserdisamt > this.variableServiceCouponMaxAmt) {
      alert(' Discount Amount Exceeds The Maximum Limit ');
      this._flashMessagesService.show(' Discount Amount Exceeds The Maximum Limit ', { cssClass: 'alert-danger' });
      this.removecoupon(this.variableServiceCouponId, '3')
    } else {

      this.varsercouponmultiple_offer = this.varsercouponmultiple_offer
      this.offer_coupon = 0;
      this.varsercouponmultiple_offer.forEach(element => {
        this.offer_coupon += element.dis_amt;
      });
      this.invoiceTotal = Math.round(this.invoiceTotal - this.varserdisamt)
      this.varsercouponmultiple_offer[0]['dis_amt'] = this.varserdisamt;
      this.varsercouponmultiple_offer[0]['ori_id'] = this.varsercouponmultiple_offer[0]['checkedItem']['ori_id'];
      this.varsercouponmultiple_offer[0]['service_offered_id'] = this.varsercouponmultiple_offer[0]['checkedItem']['service_category_id'];
      this.varsercouponmultiple_offer[0]['service_category'] = this.varsercouponmultiple_offer[0]['name'];
      this.varserdisamt1 = this.varserdisamt
      this._flashMessagesService.show('Coupon Applied', { cssClass: 'alert-success' });
      this.variableServiceCouponType = '';
    }
  }

  calvarsertotPer() {
    if (this.varserdisper > this.variableServiceCouponMaxPer) {
      alert(' Discount Amount Exceeds The Maximum Limit ');
      this._flashMessagesService.show(' Discount Amount Exceeds The Maximum Limit ', { cssClass: 'alert-danger' });
      this.removecoupon(this.variableServiceCouponId, '3')
    } else {
      this.varsercouponmultiple_offer = this.varsercouponmultiple_offer
      this.offer_coupon = 0;
      this.varsercouponmultiple_offer.forEach(element => {
        this.offer_coupon += element.dis_amt;
      });
      this.varserdisamt1 = ((this.invoiceTotal / 100) * this.varserdisper)
      this.invoiceTotal = Math.round(this.invoiceTotal - ((this.invoiceTotal / 100) * this.varserdisper))
      this.varsercouponmultiple_offer[0]['dis_amt'] = this.varserdisamt1;
      this.varsercouponmultiple_offer[0]['ori_id'] = this.varsercouponmultiple_offer[0]['checkedItem']['ori_id'];
      this.varsercouponmultiple_offer[0]['service_offered_id'] = this.varsercouponmultiple_offer[0]['checkedItem']['service_category_id'];
      this.varsercouponmultiple_offer[0]['service_category'] = this.varsercouponmultiple_offer[0]['name'];
      this._flashMessagesService.show('Coupon Applied', { cssClass: 'alert-success' });
      this.variableServiceCouponType = '';
    }
  }



  calvarprototAmt() {
    if (this.varprodisamt > this.variableProductCouponMaxAmt) {
      alert(' Discount Amount Exceeds The Maximum Limit ');
      this._flashMessagesService.show(' Discount Amount Exceeds The Maximum Limit ', { cssClass: 'alert-danger' });
      this.removeProductcoupon(this.variableProductCouponId, '3')
    } else {

      this.varprocouponproduct_multiple_offer = this.varprocouponproduct_multiple_offer
      this.product_offer_coupon = 0;
      this.varprocouponproduct_multiple_offer.forEach(element => {
        this.product_offer_coupon += element.dis_amt;
      });
      this.product_invoiceTotal = Math.round(this.product_invoiceTotal - this.varprodisamt)
      this.varprocouponproduct_multiple_offer[0]['dis_amt'] = this.varprodisamt;
      this.varprocouponproduct_multiple_offer[0]['ori_id'] = this.varprocouponproduct_multiple_offer[0]['checkedItem']['ori_id'];
      this.varprocouponproduct_multiple_offer[0]['service_offered_id'] = this.varprocouponproduct_multiple_offer[0]['checkedItem']['service_category_id'];
      this.varprocouponproduct_multiple_offer[0]['service_category'] = this.varprocouponproduct_multiple_offer[0]['name'];
      this.varprodisamt1 = this.varprodisamt
      this._flashMessagesService.show('Coupon Applied', { cssClass: 'alert-success' });
      this.variableProductCouponType = '';
    }
  }

  calvarprototPer() {
    if (this.varprodisper > this.variableProductCouponMaxPer) {
      alert(' Discount Amount Exceeds The Maximum Limit ');
      this._flashMessagesService.show(' Discount Amount Exceeds The Maximum Limit ', { cssClass: 'alert-danger' });
      this.removeProductcoupon(this.variableProductCouponId, '3')
    } else {
      this.varprocouponproduct_multiple_offer = this.varprocouponproduct_multiple_offer
      this.product_offer_coupon = 0;
      this.varprocouponproduct_multiple_offer.forEach(element => {
        this.product_offer_coupon += element.dis_amt;
      });
      // alert(this.product_invoiceTotal)
      // alert(((this.product_invoiceTotal / 100) * this.varprodisper))
      this.varprodisamt1 = ((this.product_invoiceTotal / 100) * this.varprodisper)
      // alert(this.varprodisamt1)
      this.product_invoiceTotal = Math.round(this.product_invoiceTotal - ((this.product_invoiceTotal / 100) * this.varprodisper))
      this.varprocouponproduct_multiple_offer[0]['dis_amt'] = this.varprodisamt1;
      this.varprocouponproduct_multiple_offer[0]['ori_id'] = this.varprocouponproduct_multiple_offer[0]['checkedItem']['ori_id'];
      this.varprocouponproduct_multiple_offer[0]['service_offered_id'] = this.varprocouponproduct_multiple_offer[0]['checkedItem']['service_category_id'];
      this.varprocouponproduct_multiple_offer[0]['service_category'] = this.varprocouponproduct_multiple_offer[0]['name'];
      this._flashMessagesService.show('Coupon Applied', { cssClass: 'alert-success' });
      this.variableProductCouponType = '';
    }
  }


  checkProductexist(item, index, coupon, multi_offer) {
    let found = false;
    let sam = {
      index: '',
      ori_id: '',
      service_offered_id: '',
      dis_amt: '',
      service_category: '',
      partnership_coupon: ''
    }
    if (coupon == 'productcoupon') {
      sam['type'] = 2;
    } else {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const day = String(today.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      if (this.model['mem_person'] === '1' && formattedDate <= this.model['memEndDate'] && this.model['mem_id'] == item.service_category_id) {
        sam['type'] = 7;
      } else {
        sam['type'] = 1;
      }
    }

    if (this.selected_ProductMultiOffers.length === 0) {
      sam['index'] = index;
      sam['ori_id'] = item.ori_id;
      sam['service_offered_id'] = item.service_category_id;
      sam['partnership_coupon'] = item.partnership_coupon;
      sam['dis_amt'] = multi_offer['dis_amt'];
      sam['service_category'] = item.service_category;
      this.selected_ProductMultiOffers.push(sam);
    } else {
      this.selected_ProductMultiOffers.forEach((element, i) => {
        if (element['index'] === index) {
          sam['index'] = index;
          sam['ori_id'] = item.ori_id;
          sam['service_offered_id'] = item.service_category_id;
          sam['partnership_coupon'] = item.partnership_coupon;
          sam['dis_amt'] = multi_offer['dis_amt'];
          sam['service_category'] = item.service_category;
          // Replace existing element with item
          this.selected_ProductMultiOffers[i] = sam;
          found = true;
        }
      });

      // If condition not met, add item to selected_multiOffers
      if (!found) {
        sam['index'] = index;
        sam['ori_id'] = item.ori_id;
        sam['service_offered_id'] = item.service_category_id;
        sam['partnership_coupon'] = item.partnership_coupon;
        sam['dis_amt'] = multi_offer['dis_amt'];
        sam['service_category'] = item.service_category;
        this.selected_ProductMultiOffers.push(sam);
      }
    }
  }


  checkexist(item, index, coupon, multi_offer) {
    let found = false;
    let sam = {
      index: '',
      ori_id: '',
      service_offered_id: '',
      dis_amt: '',
      service_category: '',
      partnership_coupon: ''
    }

    if (coupon == 'coupon') {
      sam['type'] = 2;
    } else {
      sam['type'] = 1;
    }

    if (this.selected_multiOffers.length === 0) {
      sam['index'] = index;
      sam['ori_id'] = item.ori_id;
      sam['service_offered_id'] = item.service_category_id;
      sam['partnership_coupon'] = item.partnership_coupon;
      sam['dis_amt'] = multi_offer['dis_amt'];
      sam['service_category'] = item.service_category;
      this.selected_multiOffers.push(sam);
    } else {
      this.selected_multiOffers.forEach((element, i) => {
        if (element['index'] === index) {
          sam['index'] = index;
          sam['ori_id'] = item.ori_id;
          sam['service_offered_id'] = item.service_category_id;
          sam['dis_amt'] = multi_offer['dis_amt'];
          sam['partnership_coupon'] = item.partnership_coupon;
          sam['service_category'] = item.service_category;
          // Replace existing element with item
          this.selected_multiOffers[i] = sam;
          found = true;
        }
      });

      // If condition not met, add item to selected_multiOffers
      if (!found) {
        sam['index'] = index;
        sam['ori_id'] = item.ori_id;
        sam['service_offered_id'] = item.service_category_id;
        sam['partnership_coupon'] = item.partnership_coupon;
        sam['dis_amt'] = multi_offer['dis_amt'];
        sam['service_category'] = item.service_category;
        this.selected_multiOffers.push(sam);
      }
    }
  }



  getKeyValues(obj: any): { key: string, value: any[] }[] {
    return Object.keys(obj).map(key => ({ key, value: obj[key] }));
  }

  ngOnDestroy() {
    this.footerService.showFooter();
  }

  addMinusProduct(type, index, name) {
    if (type == 1) {

      if (index == '7') {
        this.addMinuss7 = 1;
      }
      if (index == '8') {
        this.addMinuss8 = 1;
      }
      if (index == '9') {
        this.addMinuss9 = 1;
      }
      if (index == '10') {
        this.addMinuss10 = 1;
      }
    } else {

      if (index == '7') {
        this.addMinuss7 = '';
        this.model.productoffer7 = "";
      }

      if (index == '8') {
        this.addMinuss8 = '';
        this.model.productoffer8 = "";
      }

      if (index == '9') {
        this.addMinuss9 = '';
        this.model.productoffer9 = "";
      }

      if (index == '10') {
        this.addMinuss10 = '';
        this.model.productoffer10 = "";
      }
      this.selected_ProductMultiOffers = this.selected_ProductMultiOffers.filter(offer => offer.index !== index);
      this.product_multiple_offer = this.product_multiple_offer.filter(offer => offer.id !== index);
      this.product_offer_coupon = 0;
      this.product_multiple_offer.forEach(element => {
        this.product_offer_coupon += element.dis_amt;
      });
      this._flashMessagesService.show(name + ' Removed', { cssClass: 'alert-danger' });
      this.product_invoiceTotal = Math.round(this.tot_amt_product - this.product_offer_coupon)
    }


  }

  addMinus(type, index, name) {
    if (type == 1) {

      if (index == '2') {
        this.addMinuss2 = 1;
      }

      if (index == '3') {
        this.addMinuss3 = 1;
      }

      if (index == '4') {
        this.addMinuss4 = 1;
      }

      if (index == '5') {
        this.addMinuss5 = 1;
      }

    } else {

      if (index == '2') {
        this.addMinuss2 = '';
        this.model.offer2 = "";
      }

      if (index == '3') {
        this.addMinuss3 = '';
        this.model.offer3 = "";
      }

      if (index == '4') {
        this.addMinuss4 = '';
        this.model.offer4 = "";
      }

      if (index == '5') {
        this.addMinuss5 = '';
        this.model.offer5 = "";
      }
      this.selected_multiOffers = this.selected_multiOffers.filter(offer => offer.index !== index);
      this.multiple_offer = this.multiple_offer.filter(offer => offer.id !== index);
      this.offer_coupon = 0;
      this.multiple_offer.forEach(element => {
        this.offer_coupon += element.dis_amt;
      });
      this._flashMessagesService.show(name + ' Removed', { cssClass: 'alert-danger' });
      this.invoiceTotal = Math.round(this.tot_amt - this.disAmt - this.offer_coupon)
    }
  }



  addMinus_charge(type, index, name) {
    if (type == 1) {
      if (index == '2') {
        this.addMinuss_charge2 = 1;
        this.model.charge_name2 = "";
        this.model.add_charge2 = 0;
      }
      if (index == '3') {
        this.addMinuss_charge3 = 1;
        this.model.charge_name3 = "";
        this.model.add_charge3 = 0;
      }
      if (index == '4') {
        this.addMinuss_charge4 = 1;
        this.model.charge_name4 = "";
        this.model.add_charge4 = 0;
      }
      if (index == '5') {
        this.addMinuss_charge5 = 1;
        this.model.charge_name5 = "";
        this.model.add_charge5 = 0;
      }
    } else {
      if (index == '2') {
        this.addMinuss_charge2 = '';
        this.model.charge_name2 = "";
        this.model.add_charge2 = 0;
      }
      if (index == '3') {
        this.addMinuss_charge3 = '';
        this.model.charge_name3 = "";
        this.model.add_charge3 = 0;
      }
      if (index == '4') {
        this.addMinuss_charge4 = '';
        this.model.charge_name4 = "";
        this.model.add_charge4 = 0;
      }
      if (index == '5') {
        this.addMinuss_charge5 = '';
        this.model.charge_name5 = "";
        this.model.add_charge5 = 0;
      }
    }
  }

  changecharge(selectvalue, amtvalue, fieldname) {
    if (selectvalue == '') {
      this.model[fieldname] = 0;
    }
  }

  dateChange() {
    // alert('sss')
    if (this.model.billed_date) {
      const selectedDate = new Date(this.model.billed_date);
      const today = new Date(this.todayDate);

      // Reset if selected date is in the future
      if (selectedDate > today) {
        alert('Future dates are not allowed!');
        this.model.billed_date = ''; // Reset to today's date or clear

        // Optional: Notify backend or log this action (if required)
        return;
      }
    }
  }

  save() {
    // return false
    if (this.cus_coupon === '2' && (this.model.cus_mob == '' || !this.model.cus_mob)) {
      alert('Enter Partner No')
      return false;
    }

    if (confirm('Are you sure you want to bill with the selected date and services?')) {
      let discount = 0;
      this.discount.forEach(element => {
        discount += element.discounted_amt;
      });

      let totPay = Number(this.model['cash']) + Number(this.model['g_pay']) + Number(this.model['card']) + Number(this.model['cheque']) + Number(this.model['online_banking']) + Number(this.model['due']) + Number(this.model['salary']) - Number(this.model['advwallet'])

      // alert((Number(this.invoiceTotal) + Number(this.product_invoiceTotal) - Number(this.model.reward_point) - Number(this.model.wallet1) + Number(this.model['add_charge']) + Number(this.model['add_charge2']) + Number(this.model['add_charge3']) + Number(this.model['add_charge4']) + Number(this.model['add_charge5'])).toFixed(1))
      // alert(Number(totPay).toFixed(1))
      if ((Math.round(this.invoiceTotal * this.cgst / 100 + this.invoiceTotal * this.sgst / 100) + Math.round(this.product_invoiceTotal * this.cgst / 100 + this.product_invoiceTotal * this.sgst / 100) + Number(this.invoiceTotal) + Number(this.product_invoiceTotal) - Number(this.model.reward_point) - Number(this.model.wallet1) + Number(this.model['add_charge']) + Number(this.model['add_charge2']) + Number(this.model['add_charge3']) + Number(this.model['add_charge4']) + Number(this.model['add_charge5'])).toFixed(1) == Number(totPay).toFixed(1)) {

        this.showLoader = true;

        this.loginservice.billing(this.productsTobuy, this.chekoutArray, this.model, this.currentUser, this.discount, this.multiple_offer, this.product_multiple_offer, this.service_offered_id, this.selected_multiOffers, this.selected_ProductMultiOffers, this.varsercouponmultiple_offer, this.varprocouponproduct_multiple_offer, this.selectedProducts).subscribe(
          data => {
            this.offer_coupon = 0;
            this.multiple_offer.forEach(element => {
              this.offer_coupon += element.dis_amt;
            });

            this.product_offer_coupon = 0;
            this.product_multiple_offer.forEach(element => {
              this.product_offer_coupon += element.dis_amt;
            });

            let datas = {};
            // Add the single offer object into multiple_offer array
            if (this.varsercouponmultiple_offer && Object.keys(this.varsercouponmultiple_offer).length > 0) {
              this.multiple_offer.push(this.varsercouponmultiple_offer[0]);
            }

            // Add the single offer object into multiple_offer array
            if (this.varprocouponproduct_multiple_offer && Object.keys(this.varprocouponproduct_multiple_offer).length > 0) {
              this.product_multiple_offer.push(this.varprocouponproduct_multiple_offer[0]);
            }


            datas = {
              bill_no: data['bill_no'],
              // add_charge: data['add_charge'],
              tips: data['tips'],
              full_bill: data['full_bill'],
              customer_id: data['customer_id'],
              employee_id: data['employee_id'],
              billing_id: data['id'],
              tot_amt: this.tot_amt + this.tot_amt_product,
              servicedAmt: this.invoiceTotal,
              productAmt: this.product_invoiceTotal,
              invoiceTotal: this.invoiceTotal + this.product_invoiceTotal - this.model.reward_point - Number(this.model.wallet1),
              discount: this.discount,
              pack_discount: discount,
              offer: this.multiple_offer,
              product_offer: this.product_multiple_offer,
              productsTobuy: this.productsTobuy,
              offer_coupon_discount: this.offer_coupon
            }

            // 
            // 
            // return false;


            this.loginservice.saveInvoice(datas, this.tot_amt, this.invoiceTotal, this.multiple_offer, this.chekoutArray, this.model, this.currentUser, this.discount, this.cgst, this.sgst).subscribe(
              datat => {
                // this.showLoader = false;
                // alert(data['bill_no'])
                // this.feedback = true;
                // alert('bill')
                this.loginservice.savepaymentMode(this.model, data['bill_no'], this.currentUser)
                  .subscribe(
                    dataaas => {

                      this.showLoader = false;
                      this.router.navigate(['print'], {
                        queryParams: {
                          bill_no: JSON.stringify(data['bill_no']),
                          add_charge: JSON.stringify(datat['add_charge']),
                          billed_on: JSON.stringify(data['date']),
                          full_bill: JSON.stringify(data['full_bill']),
                          tot_amt: JSON.stringify(this.tot_amt + this.tot_amt_product),
                          invoiceTotal: JSON.stringify(this.invoiceTotal + this.product_invoiceTotal - this.model.reward_point - Number(this.model.wallet1)),
                          model: JSON.stringify(this.model),
                          multiple_offer: JSON.stringify(this.multiple_offer),
                          product_multiple_offer: JSON.stringify(this.product_multiple_offer),
                          productsTobuy: JSON.stringify(this.productsTobuy),
                          chekoutArray: JSON.stringify(this.chekoutArray),
                          discount: JSON.stringify(this.discount),
                        }
                      });
                    },
                    error => {
                      this.showLoader = false;
                      alert('Network Error SavePayment Mode API');
                    });
              },
              error => {
                this.showLoader = false;
                alert('Network Error saveInvoice API');
              });
          },
          error => {
            this.showLoader = false;
            alert('Network Error billing API');
          });
      } else {
        alert('Please Mention Mode Of Payment')
      }
    }

  }

  getcoupon(coupon, index, name, coupons) {
    // if (this.applied == 1) {
    //   alert('Coupon Already Applied')
    //   this._flashMessagesService.show('Coupon Already Applied', { cssClass: 'alert-danger' });
    // } else {
    let type: any;
    if (coupon === 'productcoupon') {
      type = 6;
    } else {
      type = 4;
    }
    this.loginservice.checkCoupon(this.model, type, this.currentUser).subscribe(
      data => {
        if (data['status'] === 'success') {
          this.cus_coupon = data['comp_details'][0]['partnership_coupon'];
          if (coupon === 'productcoupon') {
            this.productcoupons = data['comp_details'];
            this.applied = 1;
            this.product_couponIndex = this.product_couponIndex + 1;
            this.getOffersProduct(data['comp_details']['0']['service_category_id'], coupon, index, name, coupons, '')
            this.model.productcoupon = ''
          } else {
            let execute = 0;
            let execute1 = 0;

            if (parseInt(data['comp_details'][0].exc_coupon) !== 1) {
              if (data['comp_details'][0]['partnership_coupon'] == '3') {

              } else {
                Object.values(this.chekoutArray).forEach(element => {
                  if (parseInt(data['comp_details'][0].disAmt) > parseInt(element['max_dis'])) {
                    alert(element['service_category'] + ' Is Not Applicable For This Coupon Max Discount Percent Allowed is ' + element['max_dis'] + '%')
                    execute = execute + 1;
                  }
                });

                if (parseInt(data['comp_details'][0].disAmt) > this.service_percent) {
                  // alert(data['comp_details'][0].coupon + ' Is More Than Max Percent')
                  execute1 = execute1 + 1;
                }
              }
            }
            // if (execute == 0 && execute1 == 0) {
            if (execute == 0) {
              this.coupons = data['comp_details'];
              this.applied = 1;
              this.couponIndex = this.couponIndex + 1;
              this.getOffers(data['comp_details']['0']['service_category_id'], coupon, index, name, coupons)
              this.model.coupon = ''
            }
          }
        } else {
          this.model.coupon = ''
          alert('Coupon Not Valid')
          this._flashMessagesService.show('Coupon Not Valid', { cssClass: 'alert-danger' });
        }
      }, error => { alert('Network Error checkCoupon API'); });
    // }

  }

  removeProductcoupon(id, partner3) {
    this.applied = 0;
    if (id) {
      this.product_multiple_offer = this.product_multiple_offer.filter(offer => offer.id !== id);
      this.varprocouponproduct_multiple_offer = this.varprocouponproduct_multiple_offer.filter(offer => offer.id !== id);
    } else {
      this.product_multiple_offer = this.product_multiple_offer.filter(offer => offer.type !== 2);
      this.varprocouponproduct_multiple_offer = this.varprocouponproduct_multiple_offer.filter(offer => offer.type !== 2);
    }
    this.selected_ProductMultiOffers = this.selected_ProductMultiOffers.filter(offer => offer.index !== id);
    this.model.productcoupon = '';
    this.productcoupons = ''
    this.product_offer_coupon = 0;
    this.product_multiple_offer.forEach(element => {
      this.product_offer_coupon += element.dis_amt;
    });
    this.varprocouponproduct_multiple_offer.forEach(element => {
      this.product_offer_coupon += this.varprodisamt;
    });
    this._flashMessagesService.show('Coupon Removed', { cssClass: 'alert-danger' });
    this.product_invoiceTotal = Math.round(this.tot_amt_product - this.product_offer_coupon)
    if (partner3 == '3') {
      this.varprodisamt = 0;
      this.varprodisper = 0;
      this.varprodisamt1 = 0;
      this.variableProductCouponType = '';
      this.variableProductCouponId = '';
    }
  }

  removecoupon(id, partner3) {
    this.applied = 0;
    if (id) {
      this.multiple_offer = this.multiple_offer.filter(offer => offer.id !== id);
      this.varsercouponmultiple_offer = this.varsercouponmultiple_offer.filter(offer => offer.id !== id);
    } else {
      this.multiple_offer = this.multiple_offer.filter(offer => offer.type !== 2);
      this.varsercouponmultiple_offer = this.varsercouponmultiple_offer.filter(offer => offer.type !== 2);
    }
    this.selected_multiOffers = this.selected_multiOffers.filter(offer => offer.index !== id);
    this.model.coupon = '';
    this.coupons = ''
    this.offer_coupon = 0;
    this.multiple_offer.forEach(element => {
      this.offer_coupon += element.dis_amt;
    });
    this.varsercouponmultiple_offer.forEach(element => {
      this.offer_coupon += this.varserdisamt;
    });
    this._flashMessagesService.show('Coupon Removed', { cssClass: 'alert-danger' });
    this.invoiceTotal = Math.round(this.tot_amt - this.disAmt - this.offer_coupon)
    if (partner3 == '3') {
      this.varserdisamt = 0;
      this.varserdisper = 0;
      this.varserdisamt1 = 0;
      this.variableServiceCouponType = '';
      this.variableServiceCouponId = '';
    }

  }

  couponExist(id, checkedItems) {
    // let checkedItems2 = []
    let checkedItems3 = []
    // checkedItems2 = this.coupons.filter(item => item.service_category_id == id);
    if (checkedItems['0']['combine_offer'] == 'no') {
      checkedItems3 = this.multiple_offer.filter(item => item.type == 2);
      if (checkedItems3.length > 0) {
        return true;
      }
    } else {
      checkedItems3 = this.multiple_offer.filter(item => item.combine_offer == 'no');
      if (checkedItems3.length > 0) {
        return true;
      }
    }
  }


  convertToWords(number: number): string {
    // Define an array of words for numbers 0 to 19
    const units: string[] = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];

    // Define an array of words for tens multiples
    const tensMultiples: string[] = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    // Define an array of words for tens powers
    const tensPowers: string[] = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

    // Function to convert less than 1000 numbers to words
    const convertLessThanOneThousand = (number: number): string => {
      if (number === 0) {
        return '';
      }
      let word = '';
      if (number < 20) {
        word = units[number];
      } else if (number < 100) {
        word = tensMultiples[Math.floor(number / 10)] + ' ' + units[number % 10];
      } else {
        word = units[Math.floor(number / 100)] + ' Hundred ' + convertLessThanOneThousand(number % 100);
      }
      return word.trim();
    };

    // Function to convert number to words
    const convertToWordsHelper = (number: number, power: number): string => {
      if (number === 0) {
        return '';
      }
      return convertToWordsHelper(Math.floor(number / 1000), power + 1) + ' ' + convertLessThanOneThousand(number % 1000) + ' ' + tensPowers[power];
    };

    if (number === 0) {
      return 'Zero';
    }
    return convertToWordsHelper(number, 0).trim();
  }
  toNum(val) {
    return Number(val)
  }

  checkReward() {
    // alert(this.model.reward_point)
    // alert(this.customer_details.reward_points)
    if (parseFloat(this.model.reward_point) > parseFloat(this.customer_details.reward_points)) {
      alert('Given Value More Than Reward Point')
      this._flashMessagesService.show('Given Value More Than Reward Point', { cssClass: 'alert-danger' });
      this.showReward = false;
      this.model.reward_point = ''
    } else {
      this.showReward = true;
      this.model.minusReward = this.model.reward_point;
      this._flashMessagesService.show('Reward Point Applied', { cssClass: 'alert-success' });
    }
  }

  removeReward() {
    this.model.minusReward = 0;
    this.showReward = false;
    this.model.reward_point = ''
  }

  checkWallet() {
    if (this.model.wallet1 > (this.product_invoiceTotal + this.invoiceTotal)) {
      alert('Given Value More Than Invoice Amount')
      this._flashMessagesService.show('Given Value More Than Invoice Amount', { cssClass: 'alert-danger' });
      this.showWallet = false;
      this.model.wallet1 = 0;
    } else {
      if (parseFloat(this.model.wallet1) > parseFloat(this.customer_details.wallet)) {
        alert('Given Value More Than Wallet Amount')
        this._flashMessagesService.show('Given Value More Than Wallet Amount', { cssClass: 'alert-danger' });
        this.showWallet = false;
        this.model.wallet1 = 0;
      } else {
        this.showWallet = true;
        this.model.minusWallet = this.model.wallet1;
        this._flashMessagesService.show('Wallet Amount Applied', { cssClass: 'alert-success' });
      }
    }
    // alert(this.customer_details.reward_points)

  }

  removeWallet() {
    this.showWallet = false;
    this.model.minusWallet = 0;
    this.model.wallet1 = 0;
  }

  confirmcusno() {
    this.loginservice.checkCusNo(this.model.cus_mob, '', this.currentUser).subscribe(
      data => {
        if (data['status'] === 'success') {
          this.model.ref_cus_mob = this.model.cus_mob
          this.model.ref_cus_id = data['data']['id'];
          this.model.ref_cus_name = data['data']['f_name'];
        } else {
          alert('Customer No. Not Exist')
          this.model.cus_mob = '';
          this.model.ref_cus_mob = '';
          this.model.ref_cus_id = '';
          this.model.ref_cus_name = '';
        }
      }, error => { alert('Network Error checkCusNo API'); });
  }

  onPaymentMethodChange(paymentType: string) {
    const paymentMappings = {
      'mopcash': 'cash',
      'mopg_pay': 'g_pay',
      'mopcard': 'card',
      'mopcheque': 'cheque',
      'moponline_banking': 'online_banking',
      'mopsalary': 'salary',
      'mopdue': 'due',
      'mopwallet': 'advwallet'
    };

    const fieldName = paymentMappings[paymentType];
    if (this.model[paymentType] === true) {
      let totPay = Number(this.model['cash']) + Number(this.model['g_pay']) + Number(this.model['card']) + Number(this.model['cheque']) + Number(this.model['online_banking']) + Number(this.model['due']) + Number(this.model['salary']) - Number(this.model['advwallet'])
      if (totPay <= 0) {
        this.model[fieldName] = Math.round(this.product_invoiceTotal * this.cgst / 100 + this.product_invoiceTotal * this.sgst / 100) + Math.round(this.invoiceTotal * this.cgst / 100 + this.invoiceTotal * this.sgst / 100) + this.product_invoiceTotal + this.invoiceTotal + Number(this.model['add_charge']) + Number(this.model['add_charge2']) + Number(this.model['add_charge3']) + Number(this.model['add_charge4']) + Number(this.model['add_charge5']);
      } else {
        this.model[fieldName] = 0;
      }
    } else {
      this.model[fieldName] = 0;
    }
  }

  amountChange(data, type) {
    this.selectedItem = [];
    this.selectedItem = data;
    this.selectedItem['editType'] = type;
    if (type == 'product') {
      this.newAmount = data.totalCost;
      this.showAmountChangeModal = true;
    } else {
      this.newAmount = data.amount1;
      this.showAmountChangeModal = true;
    }

  }

  closeAmountModal() {
    this.showAmountChangeModal = false;
    this.selectedItem = null;
    this.newAmount = 0;
  }

  changeAmount() {
    if (this.selectedItem && this.newAmount > 0) {
      this.selectedItem.amount1 = this.newAmount;
      if (this.selectedItem['editType'] == 'service') {
        this.loginservice.changeAmount(this.selectedItem, this.currentUser).subscribe(
          data => {
            this.getcheckoutNew();
            this.closeAmountModal();
          });
      } else {
        Object.values(this.productsTobuy).forEach((typeOneItem) => {
          Object.values(typeOneItem).forEach((listItem) => {
            if (this.selectedItem.id === listItem.id) {
              listItem.totalCost = this.newAmount;
              listItem.amt_per = this.newAmount / listItem.quantity_on_sales_order;
              listItem.amount = this.newAmount / listItem.quantity_on_sales_order;
            }
          });
        });

        Object.values(this.buyingProducts).forEach((typeOneItem) => {
          typeOneItem.forEach((listItem) => {
            if (this.selectedItem.id === listItem.id) {
              this.product_invoiceTotal = this.product_invoiceTotal - listItem.totalCost;
              this.tot_amt_product = this.tot_amt_product - listItem.totalCost;
              listItem.totalCost = this.newAmount;
              listItem.amt_per = this.newAmount / listItem.quantity_on_sales_order;
              listItem.amount = this.newAmount / listItem.quantity_on_sales_order;
              this.product_invoiceTotal = this.product_invoiceTotal + this.newAmount;
              this.tot_amt_product = this.tot_amt_product + this.newAmount;
            }
          });
        });
        this.getMembership();
        this.closeAmountModal();
      }
    }
  }

  roundGst(value) {
    return Math.round(value);
  }

  getprooff(product_multiple_offer) {
    let checkedItems3 = this.product_multiple_offer.filter(item => item.type !== 7);
    if (checkedItems3.length <= 0) {
      return true;
    } else {
      return false;
    }
  }

  getAllstock_area() {
    this.loginservice.getAllstock_area(this.currentUser).subscribe(
      data => {
        if (data['status'] == 'success' && data['data'].length > 0) {
          this.stock_area_do = data['data'];
        }
      });
  }
}




// WEBPACK FOOTER //
// ./src/app/checkout/checkout.component.ts